const SET_QUICK_ANSWERS = 'SET_QUICK_ANSWERS'
const SET_QUEUE_ATTENDANCE = 'SET_QUEUE_ATTENDANCE'

const actions = {
  setAnswers (ctx, quickAnswers) {
    ctx.commit(SET_QUICK_ANSWERS, quickAnswers)
  },

  updateQueueAttendance (ctx, queueId) {
    ctx.commit(SET_QUEUE_ATTENDANCE, queueId)
  }
}

const mutations = {
  [SET_QUICK_ANSWERS]: (state, quickAnswers) => {
    state.quickAnswers = quickAnswers
  },

  [SET_QUEUE_ATTENDANCE]: (state, queueId) => {
    state.queueAttendance = queueId
  }
}

const middlewares = {
  'agentModule/SET_SESSION': (ctx, { payload }) => {
    if (!payload?.quickAnswers?.length) return
    ctx.dispatch('quickAnswersModule/setAnswers', [...payload.quickAnswers], { root: true })
  },

  'agentModule/RELOAD_SESSION': (ctx, { payload }) => {
    if (!payload?.quickAnswers?.length) return
    ctx.dispatch('quickAnswersModule/setAnswers', [...payload.quickAnswers], { root: true })
  }
}

const getters = {
  groupSuggestions: ({ quickAnswers, queueAttendance }) => {
    const categories = quickAnswers.reduce((acc, item) => {
      if (item.queueId !== queueAttendance) return acc
      const category = String(item.category || '').trim()
      if (!acc[category]) acc[category] = []
      acc[category].push({ id: item.id, label: item.answer })
      return acc
    }, {})

    const emptyCategory = categories[''] || []

    const withCategory = Object.values(
      Object.keys(categories).reduce((acc, category) => {
        if (!category) return acc
        acc[category] = { id: category }
        acc[category].label = category
        acc[category].description = `Respostas Rápidas de ${category}`
        acc[category].class = 'option-category'
        acc[category].options = categories[category]
        acc[category].selected = -1
        return acc
      }, {})
    )

    return [{
      id: 'respostas',
      label: '/respostas ',
      class: 'option-category',
      description: 'Respostas Rápidas',
      options: withCategory.concat(emptyCategory),
      selected: -1
    }]
  },

  listSuggestions: ({ quickAnswers }) => (
    quickAnswers.reduce((acc, item) => {
      const category = String(item.category || '').trim()

      acc.push({
        id: item.id,
        label: item.answer,
        class: '',
        description: category ? `Categoria: ${category}` : 'Sem categoria'
      })

      return acc
    }, []).sort((a, b) => a.label.localeCompare(b.label))
  )
}

export default {
  namespaced: true,

  getters,
  actions,
  mutations,
  middlewares,

  state: {
    updatedAt: 0,
    quickAnswers: [],
    queueAttendance: ''
  }
}
